import LoginEmailReset from '@components/Login/LoginEmailReset'

const ResetPasswordPage = () => {
  return <LoginEmailReset />
}

export default ResetPasswordPage
